import styled from '@emotion/styled';
import {
  FlexContainer,
  getColor,
  getSpace,
  GridContainer,
  Image,
} from '../../../../../../../../../ui/index.ts';

export const TitleContainer = styled(GridContainer)`
  background: ${getColor('light-purple-3')};
  padding: ${getSpace('18')};
  border-radius: 30px;
  max-width: 300px;
`;

export const TitleBlockImage = styled(Image)`
  width: 40px;
`;
